
<template>
  <div></div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

export default {
  name: "Watch",
  props: ["data"],
  data: function () {
    return {
      first: false,
    };
  },
  template: `<div></div>`,
  watch: {
    data: {
      handler: _.debounce(function () {
         console.log(this.$parent.update);
        // if (this.$parent.update) {

        //   this.$parent.update = false;
        //   return;
        // }
        axios
          .post(this.$root.app.way + "/ajax/", {
            action: "update-bill",
            data: this.data,
          })
          .then(() => {
            this.$message({
              message: "Данные успешно обновлены",
              type: "success",
            });
          });
      }, 1000),
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
